import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-9e7874e8"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "panel-wrapper__content" };
const _hoisted_2 = { class: "impact-summary-wrapper" };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-triangle" }, null, -1 /* HOISTED */));
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fa-kit fa-code-pull-request-regular" }, null, -1 /* HOISTED */));
import { useBuiltComponentVariable, useComponentDisplayName, } from "src/shared/store/component-built/composables";
import { useComponentVariableNodeType, useImpactComponentVariableImpactSummary, } from "src/shared/store/component-graph/composables";
import Button from "src/shared/v-components/ui/Button.vue";
import Dialog from "src/shared/v-components/ui/Dialog.vue";
import DrawerTrigger from "src/shared/v-components/ui/drawer/DrawerTrigger.vue";
import { computed, ref, toRef } from "vue";
import ComponentVariableImpactSummary from "./ComponentVariableImpactSummary.vue";
import ConfirmPushValueToParentDrawer from "./ConfirmPushValueToParentDrawer.vue";
import { usePushValuesToParent } from "./usePushValuesToParent";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmPushValueToParentDialog',
    props: {
        componentId: {},
        variableName: {}
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const isOpen = ref(true);
        const props = __props;
        const emit = __emit;
        const { builtComponentVariable } = useBuiltComponentVariable(props.componentId, props.variableName);
        const { parentComponentVariable } = useComponentVariableNodeType(toRef(props, "componentId"), toRef(props, "variableName"));
        const parentComponentDisplayName = computed(() => {
            var _a, _b;
            if (!((_a = parentComponentVariable.value) === null || _a === void 0 ? void 0 : _a.context.componentId)) {
                return undefined;
            }
            return useComponentDisplayName((_b = parentComponentVariable.value) === null || _b === void 0 ? void 0 : _b.context.componentId).displayName.value;
        });
        const parentVariableComponentId = computed(() => {
            var _a;
            return (_a = parentComponentVariable.value) === null || _a === void 0 ? void 0 : _a.context.componentId;
        });
        const summary = useImpactComponentVariableImpactSummary(parentVariableComponentId, toRef(props, "variableName"));
        const isPushingToParent = ref(false);
        const { push } = usePushValuesToParent(builtComponentVariable, parentComponentVariable, isPushingToParent);
        const isDrawerOpen = ref(false);
        const emitClosed = () => {
            if (!isDrawerOpen.value) {
                emit("closed");
            }
        };
        const openImpactDrawer = (open) => {
            open();
            isDrawerOpen.value = true;
            isOpen.value = false;
        };
        const impactDrawerClosed = (closed) => {
            isDrawerOpen.value = false;
            closed();
            emitClosed();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Dialog, {
                modelValue: isOpen.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isOpen).value = $event)),
                onClosed: emitClosed
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createVNode(ComponentVariableImpactSummary, {
                                size: 'large',
                                "impacted-campaign-count": _unref(summary).impactedCampaignCount,
                                "impacted-creative-count": _unref(summary).impactedCreativeCount
                            }, null, 8 /* PROPS */, ["impacted-campaign-count", "impacted-creative-count"])
                        ]),
                        _createElementVNode("p", null, [
                            _hoisted_3,
                            _createTextVNode(" Changing the default value for "),
                            _createElementVNode("strong", null, _toDisplayString(parentComponentDisplayName.value), 1 /* TEXT */),
                            _createTextVNode(" will update it everywhere the default value is used. Are you sure you want to proceed? ")
                        ]),
                        _createElementVNode("div", null, [
                            _createVNode(DrawerTrigger, null, {
                                trigger: _withCtx(({ openDrawer }) => [
                                    _createVNode(Button, {
                                        onClick: ($event) => (openImpactDrawer(openDrawer)),
                                        level: 'secondary'
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode("View Impact ")
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                ]),
                                drawer: _withCtx(({ drawerClosed }) => [
                                    _createVNode(ConfirmPushValueToParentDrawer, {
                                        onClosed: ($event) => (impactDrawerClosed(drawerClosed)),
                                        "component-id": _ctx.componentId,
                                        "variable-name": _ctx.variableName
                                    }, null, 8 /* PROPS */, ["onClosed", "component-id", "variable-name"])
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(Button, {
                                "is-pending": isPushingToParent.value,
                                onClick: _unref(push)
                            }, {
                                default: _withCtx(() => [
                                    _hoisted_4,
                                    _createTextVNode("   Yes, Update Default Value")
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["is-pending", "onClick"])
                        ])
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"]));
        };
    }
});
